/* FB | Navigasyon hizi v6 (2026-06-10) - UCAK MODU.
   v5'ten farklar:
   1) Speculation Rules'a EAGER prefetch eklendi: ekranda gorunen TUM ic linklerin HTML'i ANINDA cekilir (Chromium kendi limitini yonetir).
   2) Urun + koleksiyon linkleri icin EAGER prerender: link goruldugu anda sayfa ARKA PLANDA TAM RENDER edilir (Chrome ~10 sayfa tutar, eskisini atar) -> tikladiginda ANINDA acilir.
   3) Diger ic sayfalar icin moderate prerender (hover/dokunma niyetinde) korunur.
   4) Manuel isitma limitleri artirildi: 24->48 HTML, 60->120 gorsel (iOS/Safari icin).
   v6.1 (2026-06-11): /account icin OZEL isitma eklendi: prerender YOK (kisisel sayfa) ama dokunma/hover
   NIYETI aninda bir kez prefetch -> hesap sayfasi "soguk" acilmiyor. logout ASLA prefetch edilmez (oturumu kapatir!).
   FB (2026-08-13): Ana Sayfa '/' prerender'dan haric. Prefetch devam eder. Mobil sabit alt barin
   prerender aktivasyonunda tek kare konum kaymasini onler; urun/koleksiyon prerender akisi degismez.
   Guvenlik: Save-Data acikken HIC calismaz. /cart /checkout /account /logout haric. Tamamen additive. */
(function(){
  'use strict';
  if(window.__fbSpeed) return; window.__fbSpeed=true;
  var conn=navigator.connection||{};
  if(conn.saveData) return;

  var BAD=/\/(cart|checkout|account)|logout/;
  function okLink(a){
    if(!a||a.hostname!==location.hostname) return false;
    var h=a.href;
    if(!h||h===location.href||h.indexOf('#')!==-1||BAD.test(h)) return false;
    return true;
  }

  /* 1+2+3) Speculation Rules: eager prefetch (hepsi) + eager prerender (urun/koleksiyon) + moderate prerender (kalan).
     Ana Sayfa '/' yalnizca prerender'dan haric; prefetch kuralinda kalir. */
  var specOK=false;
  try{
    if(typeof HTMLScriptElement!=='undefined'&&HTMLScriptElement.supports&&HTMLScriptElement.supports('speculationrules')){
      specOK=true;
      var EXCL=[
        {not:{href_matches:'/cart*'}},
        {not:{href_matches:'/checkout*'}},
        {not:{href_matches:'/account*'}},
        {not:{href_matches:'*logout*'}},
        {not:{href_matches:'*/cart/*'}}
      ];
      var rules={
        prefetch:[
          {source:'document',eagerness:'moderate',where:{and:[{href_matches:'/*'}].concat(EXCL)}}
        ],
        prerender:[
          {source:'document',eagerness:'moderate',where:{and:[
            {or:[{href_matches:'/products/*'},{href_matches:'/collections/*'}]}
          ].concat(EXCL)}},
          {source:'document',eagerness:'moderate',where:{and:[
            {href_matches:'/*'},
            {not:{href_matches:'/'}}
          ].concat(EXCL)}}
        ]
      };
      var sc=document.createElement('script');
      sc.type='speculationrules';
      sc.textContent=JSON.stringify(rules);
      document.head.appendChild(sc);
    }
  }catch(e){}

  var seen={},n=0,MAX=12;
  function pf(u){
    if(!u||seen[u]||n>=MAX) return; seen[u]=1; n++;
    try{var l=document.createElement('link');l.rel='prefetch';l.href=u;document.head.appendChild(l);}catch(e){}
  }

  /* Gorsel isitma: karttaki gorselden urun sayfasi boyutlarini turet */
  var iseen={},im=0,IMAX=24;
  function warmImgWidths(a, widths){
    try{
      var card=a.closest('.fps-card, .product-card, [data-fps-url]')||a;
      var img=card.querySelector('img[src*="cdn.shopify.com"]')||a.querySelector('img[src*="cdn.shopify.com"]');
      if(!img) return;
      var src=img.currentSrc||img.src; if(!src) return;
      var base=src.replace(/([?&])width=\d+/,'$1width=W');
      if(base===src) return;
      widths.forEach(function(w){
        if(im>=IMAX) return;
        var u=base.replace('width=W','width='+w);
        if(iseen[u]) return; iseen[u]=1; im++;
        try{var l=document.createElement('link');l.rel='prefetch';l.as='image';l.href=u;document.head.appendChild(l);}catch(e){}
      });
    }catch(e){}
  }

  /* Ekran isitmasi (Speculation Rules olmayan tarayicilar icin: iOS/Safari/Firefox) */
  var io=null;
  function watch(){
    if(!io) return;
    document.querySelectorAll('a[href*="/products/"], a[href*="/collections/"]').forEach(function(a){
      if(!a.__fbWarm){a.__fbWarm=1;io.observe(a);}
    });
  }
  try{
    if('IntersectionObserver' in window){
      io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(!en.isIntersecting) return;
          var a=en.target;
          io.unobserve(a);
          if(!okLink(a)) return;
          if(!specOK) pf(a.href);
          if(!specOK && a.href.indexOf('/products/')!==-1) warmImgWidths(a,['832','1200']);
        });
      },{rootMargin:'300px'});
      if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',watch);}else{watch();}
      try{
        new MutationObserver(function(){clearTimeout(window.__fbWarmT);window.__fbWarmT=setTimeout(watch,400);})
          .observe(document.body,{childList:true,subtree:true});
      }catch(e){}
    }
  }catch(e){}

  /* Niyet aninda (dokunma/hover): son garanti */
  var rIC = window.requestIdleCallback || function(cb){ return setTimeout(cb,1); };
  function onHint(e){
    if(specOK) return;
    var a=(e.target&&e.target.closest)?e.target.closest('a[href]'):null;
    if(!okLink(a)) return;
    rIC(function(){ pf(a.href); warmImgWidths(a,['832','1200']); });
  }
  document.addEventListener('mouseover',onHint,{passive:true});
  document.addEventListener('touchstart',onHint,{passive:true});

  /* FB v6.1: /account OZEL isitma — dokunma/hover NIYETI aninda bir kez prefetch.
     Prerender bilerek YOK (kisisel/dinamik sayfa). logout iceren linke ASLA dokunma (GET ile oturum kapatir!). */
  var accPf=0;
  function accountHint(e){
    if(accPf) return;
    var a=(e.target&&e.target.closest)?e.target.closest('a[href*="/account"]'):null;
    if(!a||a.hostname!==location.hostname) return;
    if(a.href.indexOf('logout')!==-1) return;
    accPf=1;
    try{var l=document.createElement('link');l.rel='prefetch';l.href=a.href;document.head.appendChild(l);}catch(err){}
  }
  document.addEventListener('touchstart',accountHint,{passive:true});
  document.addEventListener('mouseover',accountHint,{passive:true});

  /* Geri tusu (bfcache) ile donuste yeniden tara */
  window.addEventListener('pageshow',function(ev){
    if(ev.persisted){ setTimeout(watch,80); }
  });
})();